export default __webpack_public_path__ + "static/media/iab-funnel-reviewed.bfd9a7ca.svg";